"use strict";

import jQuery from 'jquery';

/**
 * Modulevents
 * @enum {string}
 */
gc.gis.module.GCLayerTreeEvent = {
	/**
	 * Ereignis, wenn der Baum neu gerendert werden soll.
	 * @event gc.gis.module.GCLayerTreeEvent#update:start
	 */
	UPDATE_STARTED: 'update:start',
	/**
	 * Ereignis, wenn der Baum neu gerendert wurde.
	 * @event gc.gis.module.GCLayerTreeEvent#update:finished
	 */
	UPDATE_FINISHED: 'update:finished',
	/**
	 * Ereignis für den Befehl zur Änderung der Sichtbarkeit.
	 * @event gc.gis.module.GCLayerTreeEvent#toggle:visibility
	 * @property {gc.gis.layer.GCAbstractLayer} layer
	 */
	TOGGLE_VISIBILITY: 'toggle:visibility',
	/**
	 * Ereignis für den Befehl zur Änderung des Auf-/zuklappstatus.
	 * @event gc.gis.module.GCLayerTreeEvent#toggle:expand
	 * @property {gc.gis.layer.GCAbstractLayer} layer
	 */
	TOGGLE_EXPANDED: 'toggle:expand',
	/**
	 * Ereignis für den Befehl zur Änderung des Auswahlstatus.
	 * @event gc.gis.module.GCLayerTreeEvent#toggle:select
	 * @property {gc.gis.layer.GCAbstractLayer} layer
	 */
	TOGGLE_SELECTED: 'toggle:select'
};

/**
 * Hooks zum Einbinden von Aktionen in Layer-Menüs
 * @enum {string}
 */
gc.gis.module.GCLayerTreeActionHook = {
	/**
	 * Generische Aktionen für das Layermenü. Wird bei jedem Rebuild des
	 * Layerbaums reinitialisiert.
	 */
	LAYER_COMMON_ACTION: 'action:layer',
	/**
	 * Aktionen für Gruppenlayer im Layermenü. Wird bei jedem Rebuild des
	 * Layerbaums reinitialisiert.
	 */
	LAYER_GROUP_ACTION:  'action:layer:group',
	/**
	 * Aktionen für Vektorlayer im Layermenü. Wird bei jedem Rebuild des
	 * Layerbaums reinitialisiert.
	 */
	LAYER_VECTOR_ACTION: 'action:layer:vector',
	/**
	 * Aktionen für Rasterlayer im Layermenü. Wird bei jedem Rebuild des
	 * Layerbaums reinitialisiert.
	 */
	LAYER_RASTER_ACTION: 'action:layer:raster'
};

/**
 * @classdesc
 * Layerbaum-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}]
 * @param {string} [options.label='Ebenen']
 * @param {boolean} [options.dragAndDrop=true] Drag-And-Drop aktivieren?
 */
gc.gis.module.GCLayerTree = function(options)
{
	gc.gis.module.GCAbstractModule.call( this, options );

	var self = this;

	this.label         = options.label || 'Ebenen';
	this.map           = options.map || gc.gis.iface.map;
	this.drag_and_drop = gc.gis.GCUtil.parseBool( options.dragAndDrop, true );

	this._wms_provider = gc.gis.iface.mapFactory.createWMSProvider(gc.gis.iface.request, this.map);
	this._wfs_provider = gc.gis.iface.mapFactory.createWFSProvider({});

    // Panel-Widgets
    this.element_panel_main = new gc.gis.module.GCLayerTree.Panel({
        module: self,
        active: self.active,
        headline: self.label
    });

    this.element_panel_legend = new gc.gis.module.GCLayerTree.LegendPanel({
        module: self,
        map: this.map
    });

    // Sidebar-Content
    this._sidebar_content = new gc.gis.ui.GCSidebarContent({
        label:   this.label,
        'parent': null,
        element: this.element_panel_main.getElement()
    });

    this.launcher = {
        label: this.label,
        icon: 'ms ms-layers',
        content: this._sidebar_content
    };
    gc.gis.iface.ui.sidebar.addLauncher(this.launcher);

    this._sidebar_content_legend = new gc.gis.ui.GCSidebarContent({
        label: 'Legende',
        'parent': this._sidebar_content,
        launcher: this.launcher.element,
        element: this.element_panel_legend.getElement()
    });

    // Toolbar vom Hauptpanel erweitern
    this.element_panel_main.getToolbar().addItem(new gc.gis.widget.GCItem({
        label: 'Legende',
        className: 'btn btn-default',
        click: function (evt) {
            gc.gis.iface.ui.sidebar.setContent(self._sidebar_content_legend);
            self.element_panel_legend.updateList();
        }
    }));

	this.map.on( gc.gis.map.GCMapEvent.LAYER_ADDED, this, function(evt) {
        // console.debug('Add-Layer: ');
        // self.redrawLayertree();
		for (var i=0; i<evt.layers.length; i++)
		{
            self.element_panel_main.addLayer(evt.layers[i]);
		}
	});
	this.map.on(gc.gis.map.GCMapEvent.LAYER_REMOVED, this, function(evt) {
        // console.debug('Remove-Layer: ');
		// self.redrawLayertree();
        for (var i=0; i<evt.layers.length; i++)
        {
            self.element_panel_main.removeLayer(evt.layers[i]);
        }
	});
	this.map.on(gc.gis.map.GCMapEvent.LAYER_MOVED, this, function(evt) {
        // console.debug('Move-Layer: ');
        // self.redrawLayertree();
        self.element_panel_main.moveLayers((evt.source_layer || evt.source_layers), evt.target_layer, evt.index);
	});
	// CSC 2017-07-06: warum ist das notwendig?? Es wurden die Layer der Kartenbibliothek erzeugt.
	//this.map.on( gc.gis.map.GCMapEvent.LAYER_TREE_UPDATE_FINISHED, this, function(evt) {self.redrawLayertree();} );

	gc.gis.iface.ui.sidebar.on( gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function( evt ) {
		if( evt.newValue === self.launcher.content )
		{
            // CSC 2017-07-06: warum ist das notwendig??
			// Wahrscheinlich nicht notwendig, aber wird vorerst zu Kontrollzwecken drin gelassen
			self.redrawLayertree();
		}
	});
    // CSC 2017-07-06: Layer gibt es jetzt noch keine
	//this.redrawLayertree();
};
gc.gis.module.GCLayerTree.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 * @public
 * @method
 *
 * @return {gc.gis.module.GCLayerTree.Panel}
 */
gc.gis.module.GCLayerTree.prototype.getMainPanel = function ()
{
    return this.element_panel_main;
};

/**
 * @public
 * @method
 *
 * @return {jQuery}
 */
gc.gis.module.GCLayerTree.prototype.getElement = function()
{
    return this.getMainPanel().getElement();
};

/**
 * Hilfsfunktion, welche zu einem Layer ein jQuery-Element der Legendengrafik bereitstellt.
 *
 * @public
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @return {jQuery} jQuery-Element
 */
gc.gis.module.GCLayerTree.prototype.createLegendElement = function (layer)
{
    if (layer instanceof gc.gis.layer.GCRasterLayer) {
        return this._wms_provider.getLegendGraphic(layer);
    }
    else if (layer instanceof gc.gis.layer.GCVectorLayer) {
        return this._wfs_provider.getLegendGraphic(layer);
    }

    gc.gis.iface.log.debug(this, 'ERROR: unknown layer type for layer "' + layer.getLabel() + '": ' + layer.getType());
    return jQuery('<em>', {
        text: 'Ebene unterstützt keine Legendengrafik.'
    });
};

/**
 * Veranlasst das (neu-)rendern des Layerbaums
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerTree.prototype.redrawLayertree = function()
{
    this.element_panel_main.redrawTree();
};

/**
 * TODO
 * @param wcs_file
 */
gc.gis.module.GCLayerTree.prototype.restoreLayerStates = function( wcs_file )
{
};

/**
 * Gibt die Anzahl der markierten Layer zurück.
 *
 * @public
 * @method
 *
 * @returns {number}
 */
gc.gis.module.GCLayerTree.prototype.getSelectionCount = function()
{
	return this.map.getRoot().getLayersRecursive( function( layer ) {
		return layer.isSelected();
	}).length;
};

/**
 * Callback, beim (de-)selektieren eines Layers.
 *
 * @public
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.module.GCLayerTree.prototype.onToggleSelection = function( layer )
{
	this._fireEvent( gc.gis.module.GCLayerTreeEvent.TOGGLE_SELECTED, {
		layer: layer
	});
};
